import React, { useState } from 'react';
import { SnapDialog, Button, TextField } from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function VerificationPage({
  isVisible,
  onClose,
  totalAmount,
  phoneNumber,
  onContinue,
  goBack
}) {
  const [verificationCode, setVerificationCode] = useState('123456');

  const handleInputChange = (event) => {
    setVerificationCode(event.target.value);
  };

  const isVerificationCodeValid = /^\d{6}$/.test(verificationCode);

  const handleVerifyClick = () => {
    if (isVerificationCodeValid) {
      onContinue();
    }
  };

  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      className="custom-dialog-sm-width"
    >
      <div className="verification-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="lto-mob-vcode-1">Enter the verification code</div>
          <div className="lto-mob-vcode-2">
            We sent a code to {phoneNumber}.
          </div>
          <br />
          <div>
            <TextField
              label="Verification Code"
              className="verification-input"
              fullWidth
              inputProps={{ maxLength: 6 }}
              value={verificationCode}
              onChange={handleInputChange}
            />
          </div>
          <br />
          <div className="resend-code">Resend Code</div>
          <br />
          <Button
            className="continue-button"
            disabled={!isVerificationCodeValid}
            onClick={handleVerifyClick}
          >
            Verify
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

VerificationPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired
};

export default VerificationPage;
